export const environment = {
    production: true,
    api: 'https://alertia-pa-msjcontigo-dev.azurewebsites.net/api/',
    stripe_pk: "pk_test_9ZqK4P80vk40343gIeTOBqOa",
    firebaseConfig: {
        apiKey: "AIzaSyDWUBXmSgj5Af178JLrOc6kuysC_Evt7J8",
        authDomain: "alertia-panicalert-msjcontigo.firebaseapp.com",
        projectId: "alertia-panicalert-msjcontigo",
        storageBucket: "alertia-panicalert-msjcontigo.firebasestorage.app",
        messagingSenderId: "554751556560",
        appId: "1:554751556560:web:a948efaa3e5a1d68ee97d5",
        measurementId: "G-WXG0TZZ67J",
        path: "devConversations"
    } ,
    privacyPolicy: "https://alertia-pa-msjcontigo-dev.azurewebsites.net/privacyPolicy",
    termsConditions: "https://alertia-pa-msjcontigo-dev.azurewebsites.net/termsService"
};